export const stripMarkdownLinks = (cell: string) =>
  cell
    .replace(
      /\[[^\]]*]\(compound:\/\/[^?]*\?([^)]*)\)/g,
      (_full, query: string) => new URLSearchParams(query).get('alias') ?? '',
    )
    .replace(/\[([^\]]+)]\([^)]+\)/g, '$1');

export const cutString = (s: string, n: number) => {
  if (s.length > n) {
    return `${s.slice(0, n)}...`;
  }
  return s;
};

export const capitalise = (value: string) => value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();

export const getFullName = ({
  firstName,
  lastName,
  email,
}: {
  firstName?: string;
  lastName?: string;
  email?: string;
}) => [firstName, lastName].filter(Boolean).join(' ').trim() || (email ?? '');

export const getInitials = ({
  firstName,
  lastName,
  email,
}: {
  firstName?: string;
  lastName?: string;
  email?: string;
}) =>
  `${firstName?.charAt(0) ?? ''}${lastName?.charAt(0) ?? ''}`.toUpperCase() || (email?.charAt(0).toUpperCase() ?? '');

export const stripExtension = (fileName: string) => fileName.replace(/\.[^.]+$/, '');

export const pluralise = (count: number, noun: string) => `${count} ${noun}${count === 1 ? '' : 's'}`;

export const linkedTemplatesLabel = (count: number) => `Linked to ${pluralise(count, 'template')}`;

const MAX_LISTED = 5;

// Long lists end in "and N more" so a big batch doesn't flood the message.
export const formatShortList = (items: (string | number)[]) => {
  const shown = items.slice(0, MAX_LISTED);
  const remaining = items.length - shown.length;
  return `${shown.join(', ')}${remaining > 0 ? `, and ${remaining} more` : ''}`;
};

const HTML_ENTITIES: Record<string, string> = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'",
  '&apos;': "'",
};

export const decodeHtmlEntities = (input: string) =>
  input.replace(/&(?:amp|lt|gt|quot|#39|apos);/g, match => HTML_ENTITIES[match] ?? match);

const ESCAPE_HTML_ENTITIES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

export const escapeHtml = (input: string) => input.replace(/[&<>"']/g, char => ESCAPE_HTML_ENTITIES[char] ?? char);
export const matchesNameFilter = (name: string, filter: string) =>
  name.toLowerCase().includes(filter.trim().toLowerCase());
